import api from './api';

export interface PermissionDeniedRow {
  id: number;
  user_email: string;
  method: string;
  path: string;
  page_url: string | null;
  message: string | null;
  user_agent: string | null;
  ip_address: string | null;
  created_at: string;
}

export interface PermissionDeniedList {
  rows: PermissionDeniedRow[];
  total: number;
}

const permissionDeniedLogService = {
  async getRecent(): Promise<PermissionDeniedList> {
    const response = await api.get<PermissionDeniedList>('/permission-denied-log');
    return response.data;
  },
};

export default permissionDeniedLogService;
